import React from "react";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Imagini pentru tratamente pardoseli
import t1 from "assets/images/poze-site/12-1-trat-pard.webp";
import t2 from "assets/images/poze-site/12-2-trat-pard.webp";
import t3 from "assets/images/poze-site/12-3-trat-pard.webp";
import t4 from "assets/images/poze-site/12-4-trat-pard.webp";
import t5 from "assets/images/poze-site/12-5-trat-pard.webp";
import t6 from "assets/images/poze-site/12-6-trat-pard.webp";
import t7 from "assets/images/poze-site/12-7-trat-pard.webp";
import t8 from "assets/images/poze-site/12-8-trat-pard.webp";
import t9 from "assets/images/poze-site/12-9-trat-pard.webp";

const images = [t1, t2, t3, t4, t5, t6, t7, t8, t9];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Tratamente speciale aplicate pardoselilor
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix, toate la fel
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Tratamente pardoseli ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
